export default "__VITE_ASSET__aed85167__"